import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MomentModule } from 'angular2-moment';
import { WebVitalsService } from './services/WebVitals.service';
import { WebVitalsListComponent } from './components/scripts/webVitalsList.component';
import { WebVitalsRoutingModule } from './WebVitals-routing.module';

@NgModule({
  imports: [
    CommonModule,
    MomentModule,
    WebVitalsRoutingModule
  ],
  declarations: [
    WebVitalsListComponent
  ],
  providers: [
    WebVitalsService
  ],
  entryComponents: [WebVitalsListComponent]
})

export class WebVitalsModule { }



// WEBPACK FOOTER //
// ./src/app/webVitals/webVitals.module.ts